module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_m_normal.acd37ffb.png";